import { forwardRef } from 'react';
import type { ViewProps } from './View';
import { View } from './View';

export type XStackProps = Omit<ViewProps, 'flexDirection'>;

export const XStack = forwardRef<HTMLDivElement, XStackProps>((props, ref) => (
  <View flexDirection="row" ref={ref} {...props} />
));
